
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from '@/components/ui/toaster';
import { HelmetProvider } from 'react-helmet-async';
import { ImagePreloadProvider } from '@/components/context/ImagePreloadContext';
import Layout from '@/components/Layout';
import Index from '@/pages/Index';
import Collections from '@/pages/Collections';
import Collection from '@/pages/Collection';
import SharedCollection from '@/pages/SharedCollection';
import Place from '@/pages/Place';
import Profile from '@/pages/Profile';
import Auth from '@/pages/Auth';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import Sitemap from '@/pages/Sitemap';
import Recommendations from '@/pages/Recommendations';
import Search from '@/pages/Search';
import Wizard from '@/pages/Wizard';
import VisaRequirementsPage from '@/pages/VisaRequirementsPage';
import Trips from '@/pages/Trips';
import Availability from '@/pages/Availability';
import NotFound from '@/pages/NotFound';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      gcTime: 10 * 60 * 1000, // 10 minutes
    },
  },
});

function App() {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ImagePreloadProvider>
          <Router>
            <Layout>
              <Routes>
                <Route path="/" element={<Index />} />
                <Route path="/search" element={<Search />} />
                <Route path="/wizard" element={<Wizard />} />
                <Route path="/collections" element={<Collections />} />
                <Route path="/collections/:name/:id" element={<Collection />} />
                <Route path="/shared/:id" element={<SharedCollection />} />
                {/* Old place URL format for backward compatibility */}
                <Route path="/places/:id" element={<Place />} />
                {/* New SEO-friendly place URL format */}
                <Route path="/places/:country/:city/:type/:name/:id" element={<Place />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/sitemap" element={<Sitemap />} />
                <Route path="/recommendations" element={<Recommendations />} />
                <Route path="/visa-requirements" element={<VisaRequirementsPage />} />
                <Route path="/trips" element={<Trips />} />
                <Route path="/availability" element={<Availability />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </Layout>
            <Toaster />
          </Router>
        </ImagePreloadProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
